import * as React from 'react';

const CartePaypal = props => (
  <svg
    id="Livello_1"
    data-name="Livello 1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 2043.11 273.84"
    {...props}
  >
    <defs>
      <linearGradient
        id="Sfumatura_senza_nome_3"
        data-name="Sfumatura senza nome 3"
        x1={1810.22}
        y1={639.29}
        x2={1798.23}
        y2={620.52}
        gradientTransform="translate(0 -500)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0} stopColor="#f89f20" />
        <stop offset={0.25} stopColor="#f79a20" />
        <stop offset={0.53} stopColor="#f68d20" />
        <stop offset={0.62} stopColor="#f58720" />
        <stop offset={0.72} stopColor="#f48120" />
        <stop offset={1} stopColor="#f37521" />
      </linearGradient>
      <linearGradient
        id="Sfumatura_senza_nome_2"
        data-name="Sfumatura senza nome 2"
        x1={1808.33}
        y1={639.03}
        x2={1790.81}
        y2={604.8}
        gradientTransform="translate(0 -500)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0} stopColor="#f58720" />
        <stop offset={0.36} stopColor="#e16f27" />
        <stop offset={0.7} stopColor="#d4602c" />
        <stop offset={0.98} stopColor="#d05b2e" />
      </linearGradient>
      <linearGradient
        id="Sfumatura_senza_nome_6"
        data-name="Sfumatura senza nome 6"
        x1={377.54}
        y1={185.44}
        x2={404.91}
        y2={185.44}
        gradientTransform="matrix(2.05 0 0 -2.05 740.97 524.86)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0} stopColor="#007940" />
        <stop offset={0.23} stopColor="#00873f" />
        <stop offset={0.74} stopColor="#40a737" />
        <stop offset={1} stopColor="#5cb531" />
      </linearGradient>
      <linearGradient
        id="Sfumatura_senza_nome_6-2"
        x1={377.54}
        y1={189.67}
        x2={404.89}
        y2={189.67}
        xlinkHref="#Sfumatura_senza_nome_6"
      />
      <linearGradient
        id="Sfumatura_senza_nome_6-3"
        x1={377.54}
        y1={194.33}
        x2={404.91}
        y2={194.33}
        xlinkHref="#Sfumatura_senza_nome_6"
      />
      <linearGradient
        id="Sfumatura_senza_nome_4"
        data-name="Sfumatura senza nome 4"
        x1={316.25}
        y1={189.7}
        x2={344.05}
        y2={189.7}
        gradientTransform="matrix(2.05 0 0 -2.05 740.97 524.86)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0} stopColor="#1f286f" />
        <stop offset={0.48} stopColor="#004e94" />
        <stop offset={0.83} stopColor="#0066b1" />
        <stop offset={1} stopColor="#006fbc" />
      </linearGradient>
      <linearGradient
        id="Sfumatura_senza_nome_5"
        data-name="Sfumatura senza nome 5"
        x1={346.75}
        y1={189.64}
        x2={373.75}
        y2={189.64}
        gradientTransform="matrix(2.05 0 0 -2.05 740.97 524.86)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0} stopColor="#6c2c2f" />
        <stop offset={0.17} stopColor="#882730" />
        <stop offset={0.57} stopColor="#be1833" />
        <stop offset={0.86} stopColor="#dc0436" />
        <stop offset={1} stopColor="#e60039" />
      </linearGradient>
      <style>
        {
          '.cls-1{fill:#00579f}.cls-3{fill:#231f20}.cls-5{fill:#eb001b}.cls-6{fill:#f79e1b}.cls-8{fill:#00a2e5}.cls-9{fill:#fff}.cls-13{fill:#016fd0}'
        }
      </style>
    </defs>
    <g id="g4158">
      <path
        id="polygon9"
        className="cls-1"
        d="M254.93 180.52h-22.47l14.05-86.91h22.47l-14.05 86.91z"
      />
      <path
        id="path11"
        className="cls-1"
        d="M336.39 95.73A55.32 55.32 0 0 0 316.24 92c-22.2 0-37.82 11.83-37.92 28.75-.18 12.49 11.19 19.42 19.7 23.58 8.69 4.25 11.65 7 11.65 10.82-.09 5.82-7 8.51-13.5 8.51-9 0-13.78-1.39-21.08-4.62l-3-1.39-3.09 19.54c5.27 2.4 15 4.53 25.06 4.62 23.58 0 38.93-11.65 39.12-29.68.09-9.89-5.92-17.47-18.87-23.67-7.86-4-12.67-6.66-12.67-10.73.09-3.69 4.07-7.48 12.94-7.48a38 38 0 0 1 16.74 3.33l2 .92 3.05-18.77Z"
      />
      <path
        id="path13"
        className="cls-1"
        d="m366.26 149.73 9-24.32c-.09.19 1.85-5.08 3-8.32l1.57 7.49s4.25 20.8 5.18 25.15ZM394 93.61h-17.38c-5.36 0-9.44 1.57-11.75 7.21l-33.38 79.69h23.58l4.72-13h28.85c.64 3.05 2.68 13 2.68 13h20.81L394 93.61Z"
      />
      <path
        id="path15"
        className="cls-1"
        d="m213.69 93.61-22 59.26-2.41-12c-4.06-13.87-16.83-28.94-31.07-36.43l20.16 76h23.77l35.32-86.81Z"
      />
      <path
        id="path17"
        d="M171.24 93.61h-36.15l-.37 1.75c28.2 7.21 46.88 24.6 54.55 45.49l-7.86-39.94c-1.29-5.55-5.27-7.12-10.17-7.3Z"
        style={{
          fill: '#faa61a',
        }}
      />
    </g>
    <path
      className="cls-3"
      d="M550 214.28v-10.36a6.15 6.15 0 0 0-5.71-6.56 6.91 6.91 0 0 0-.79 0 6.41 6.41 0 0 0-5.8 2.94 6.07 6.07 0 0 0-5.45-2.94 5.47 5.47 0 0 0-4.84 2.46v-2h-3.59v16.51h3.63v-9.16a3.85 3.85 0 0 1 3.29-4.35 3.14 3.14 0 0 1 .75 0c2.38 0 3.59 1.55 3.59 4.35v9.19h3.62v-9.16a3.89 3.89 0 0 1 3.37-4.35 3.76 3.76 0 0 1 .67 0c2.46 0 3.63 1.55 3.63 4.35v9.19Zm53.66-16.51h-5.87v-5h-3.63v5h-3.35v3.28h3.35v7.53c0 3.83 1.49 6.11 5.74 6.11a8.51 8.51 0 0 0 4.49-1.28l-1-3.07a6.71 6.71 0 0 1-3.18.93c-1.79 0-2.38-1.1-2.38-2.76v-7.46h5.87Zm30.63-.42a4.89 4.89 0 0 0-4.35 2.42v-2h-3.56v16.51H630V205c0-2.73 1.18-4.25 3.53-4.25a5.72 5.72 0 0 1 2.24.42l1.11-3.39a8 8 0 0 0-2.56-.45ZM588 199.08a12.34 12.34 0 0 0-6.73-1.73c-4.18 0-6.87 2-6.87 5.29 0 2.69 2 4.35 5.69 4.87l1.7.24c2 .27 2.9.79 2.9 1.73 0 1.27-1.31 2-3.77 2a8.76 8.76 0 0 1-5.49-1.73l-1.69 2.8a11.92 11.92 0 0 0 7.15 2.14c4.76 0 7.53-2.24 7.53-5.39 0-2.9-2.18-4.42-5.77-4.94l-1.69-.24c-1.56-.2-2.8-.52-2.8-1.62s1.17-1.93 3.14-1.93a10.59 10.59 0 0 1 5.15 1.41Zm96.21-1.73a4.89 4.89 0 0 0-4.35 2.42v-2h-3.56v16.51h3.6V205c0-2.73 1.17-4.25 3.52-4.25a5.72 5.72 0 0 1 2.24.42l1.11-3.39a8 8 0 0 0-2.56-.45ZM638 206a8.35 8.35 0 0 0 8 8.68 7.3 7.3 0 0 0 .81 0 8.6 8.6 0 0 0 5.94-2l-1.72-2.9a7.28 7.28 0 0 1-4.32 1.49 5.29 5.29 0 0 1 0-10.57 7.32 7.32 0 0 1 4.32 1.48l1.72-2.9a8.7 8.7 0 0 0-5.94-2 8.36 8.36 0 0 0-8.8 7.86v.81Zm33.63 0v-8.25H668v2a6.29 6.29 0 0 0-5.21-2.42 8.68 8.68 0 0 0 0 17.34 6.23 6.23 0 0 0 5.21-2.42v2h3.59Zm-13.36 0a5 5 0 1 1 0 .4c-.06-.11-.06-.25-.05-.4Zm-43.34-8.67a8.68 8.68 0 0 0 .24 17.34 10 10 0 0 0 6.77-2.31l-1.76-2.66a7.85 7.85 0 0 1-4.8 1.72 4.58 4.58 0 0 1-4.94-4h12.26c0-.45.07-.89.07-1.38 0-5.14-3.21-8.67-7.84-8.67Zm-.07 3.22a4.09 4.09 0 0 1 4.18 4h-8.57a4.25 4.25 0 0 1 4.39-4Zm90.1 5.45v-14.86h-3.59v8.63a6.3 6.3 0 0 0-5.22-2.42 8.68 8.68 0 0 0 0 17.34 6.25 6.25 0 0 0 5.22-2.42v2h3.59Zm6 5.86a1.75 1.75 0 0 1 .65.13 1.58 1.58 0 0 1 .53.35 1.47 1.47 0 0 1 .36.53 1.56 1.56 0 0 1 0 1.27 1.52 1.52 0 0 1-.36.52 1.58 1.58 0 0 1-.53.35 1.43 1.43 0 0 1-.65.13 1.64 1.64 0 0 1-1.55-2.27 1.77 1.77 0 0 1 .36-.53 1.58 1.58 0 0 1 .53-.35 1.89 1.89 0 0 1 .66-.13Zm0 2.92a1.24 1.24 0 0 0 .5-.1 1.23 1.23 0 0 0 .4-.27 1.28 1.28 0 0 0 0-1.81 1.09 1.09 0 0 0-.4-.27 1.3 1.3 0 0 0-1 0 1.22 1.22 0 0 0-.41.27 1.28 1.28 0 0 0 0 1.81 1.22 1.22 0 0 0 .41.27 1.24 1.24 0 0 0 .5.1Zm.1-2a.66.66 0 0 1 .45.13.4.4 0 0 1 .16.35.39.39 0 0 1-.12.31.55.55 0 0 1-.36.15l.49.58h-.39l-.46-.57h-.15v.57h-.32v-1.52Zm-.38.28v.41h.32a.46.46 0 0 0 .2 0 .21.21 0 0 0 .08-.16.18.18 0 0 0-.08-.15.46.46 0 0 0-.2-.05Zm-19.07-7a5 5 0 1 1 0 .4.853.853 0 0 1-.07-.46Zm-121.28 0v-8.25h-3.59v2a6.29 6.29 0 0 0-5.21-2.42 8.68 8.68 0 0 0 0 17.34 6.23 6.23 0 0 0 5.21-2.42v2h3.59Zm-13.36 0a5 5 0 1 1 0 .4v-.4Z"
    />
    <path
      style={{
        fill: '#ff5f00',
      }}
      d="M586.82 71.97h54.4v97.75h-54.4z"
    />
    <path
      className="cls-5"
      d="M590.27 120.85A62.08 62.08 0 0 1 614 72a62.17 62.17 0 1 0 0 97.75 62.06 62.06 0 0 1-23.73-48.9Z"
    />
    <path
      className="cls-6"
      d="M714.6 120.85A62.16 62.16 0 0 1 614 169.72 62.2 62.2 0 0 0 614 72a62.17 62.17 0 0 1 100.6 48.85ZM708.67 159.37v-2h.81V157h-2.06v.41h.81v2Zm4 0V157H712l-.72 1.66-.73-1.66H710v2.41h.45v-1.82l.67 1.57h.47l.68-1.57v1.82Z"
    />
    <path d="M876.92 214.13v-10.32a6.13 6.13 0 0 0-5.68-6.54 5.21 5.21 0 0 0-.79 0 6.4 6.4 0 0 0-5.79 2.92 6 6 0 0 0-5.43-2.92 5.43 5.43 0 0 0-4.82 2.44v-2h-3.58v16.45h3.61V205a3.85 3.85 0 0 1 3.28-4.34 4.71 4.71 0 0 1 .75 0c2.37 0 3.58 1.55 3.58 4.34v9.15h3.61V205a3.88 3.88 0 0 1 3.36-4.34 3.76 3.76 0 0 1 .67 0c2.44 0 3.62 1.55 3.62 4.34v9.15Zm20.17-8.22v-8.23h-3.58v2a6.23 6.23 0 0 0-5.2-2.41 8.65 8.65 0 0 0 0 17.28 6.26 6.26 0 0 0 5.2-2.41v2h3.58Zm-13.32 0a4.94 4.94 0 1 1 0 .39c-.01-.13-.01-.3 0-.39Zm89.93-8.66a9.33 9.33 0 0 1 3.53.66 8.83 8.83 0 0 1 2.81 1.82 8.4 8.4 0 0 1 1.85 2.74 9.08 9.08 0 0 1 0 6.87 8.4 8.4 0 0 1-1.85 2.74 8.5 8.5 0 0 1-2.81 1.82 9.69 9.69 0 0 1-7.07 0 8.46 8.46 0 0 1-2.8-1.82 8.22 8.22 0 0 1-1.84-2.74 9.08 9.08 0 0 1 0-6.87 8.37 8.37 0 0 1 1.84-2.74 8.62 8.62 0 0 1 2.8-1.82 9.35 9.35 0 0 1 3.54-.66Zm0 3.38a5.53 5.53 0 0 0-2.05.39 4.69 4.69 0 0 0-1.65 1.08 5 5 0 0 0-1.08 1.67 6 6 0 0 0 0 4.28 4.9 4.9 0 0 0 2.71 2.75 5.66 5.66 0 0 0 4.09 0 4.94 4.94 0 0 0 2.73-2.75 6 6 0 0 0 0-4.28 5 5 0 0 0-1.09-1.67 5 5 0 0 0-1.64-1.08 5.48 5.48 0 0 0-2.02-.39Zm-57.13 5.28c0-5.13-3.2-8.64-7.81-8.64a8.65 8.65 0 0 0 .24 17.28 10.06 10.06 0 0 0 6.75-2.31l-1.75-2.65a7.79 7.79 0 0 1-4.78 1.72 4.57 4.57 0 0 1-4.93-4h12.21c.04-.47.07-.92.07-1.4Zm-12.25-1.45a4.23 4.23 0 0 1 4.37-4 4.08 4.08 0 0 1 4.16 4Zm27.33-2.58a10.62 10.62 0 0 0-5.13-1.41c-2 0-3.13.72-3.13 1.93s1.24 1.41 2.79 1.61l1.68.24c3.58.52 5.75 2 5.75 4.93 0 3.13-2.75 5.37-7.5 5.37a11.86 11.86 0 0 1-7.13-2.14l1.69-2.79a8.76 8.76 0 0 0 5.47 1.73c2.44 0 3.75-.73 3.75-2 0-.93-.93-1.45-2.89-1.72l-1.69-.24c-3.68-.52-5.67-2.17-5.67-4.86 0-3.27 2.68-5.26 6.85-5.26a12.28 12.28 0 0 1 6.71 1.73Zm17.2-.93H943v7.44c0 1.65.58 2.75 2.37 2.75a6.68 6.68 0 0 0 3.17-.93l1 3.06a8.41 8.41 0 0 1-4.47 1.28c-4.24 0-5.72-2.27-5.72-6.1V201h-3.33v-3.27h3.33v-5H943v5h5.85Zm12.39-3.68a7.64 7.64 0 0 1 2.55.44l-1.1 3.38a5.78 5.78 0 0 0-2.24-.42c-2.34 0-3.51 1.52-3.51 4.24v9.22h-3.58v-16.45h3.54v2a4.84 4.84 0 0 1 4.34-2.41ZM986 211.74a1.56 1.56 0 0 1 .64.13 1.58 1.58 0 0 1 .53.35 1.67 1.67 0 0 1 .36.52 1.64 1.64 0 0 1 0 1.27 1.67 1.67 0 0 1-.89.87 1.41 1.41 0 0 1-.64.13 1.65 1.65 0 0 1-1.55-1 1.56 1.56 0 0 1 0-1.27 1.64 1.64 0 0 1 .35-.52 1.73 1.73 0 0 1 .54-.35 1.62 1.62 0 0 1 .66-.13Zm0 2.91a1.23 1.23 0 0 0 .49-.1 1.34 1.34 0 0 0 .4-.27 1.29 1.29 0 0 0-.4-2.08 1.43 1.43 0 0 0-.49-.1 1.45 1.45 0 0 0-.51.1 1.62 1.62 0 0 0-.41.27 1.28 1.28 0 0 0 .92 2.18Zm.09-2a.72.72 0 0 1 .45.13.42.42 0 0 1 .16.36.41.41 0 0 1-.12.31.68.68 0 0 1-.36.15l.49.57h-.39l-.46-.57h-.15v.57h-.32v-1.52Zm-.38.28v.41h.38a.35.35 0 0 0 .2-.05.18.18 0 0 0 .08-.15.21.21 0 0 0-.08-.16.46.46 0 0 0-.2-.05Z" />
    <path
      style={{
        fill: '#7375cf',
      }}
      d="M889.47 72.1h54.3v97.57h-54.3z"
    />
    <path
      className="cls-5"
      d="M892.91 120.88a62 62 0 0 1 23.7-48.78 62.05 62.05 0 1 0 0 97.57 62 62 0 0 1-23.7-48.79Z"
    />
    <path
      className="cls-8"
      d="M1011.09 159.33v-2h.8v-.41h-2v.41h.81v2Zm4 0v-2.41h-.63l-.72 1.66-.73-1.66h-.62v2.41h.44v-1.81l.68 1.56h.46l.68-1.57v1.82ZM1017 120.88a62.06 62.06 0 0 1-100.4 48.79 62 62 0 0 0 0-97.57 62 62 0 0 1 100.4 48.78Z"
    />
    <path
      className="cls-9"
      d="M1684.32 65.89h223.25v142.12h-223.19l-.06-142.12z"
    />
    <path
      d="M1906.8 144.94s-61 43-172.72 62.3h172.72Z"
      style={{
        fill: '#f48120',
      }}
    />
    <path
      className="cls-3"
      d="M1907.57 65.06h-224v143.78h224.84V65h-.82Zm-.77 1.6v140.52h-221.59V66.66Z"
    />
    <path
      className="cls-3"
      d="M1703.19 109h-9.29v32.55h9.29c4.92 0 8.47-1.19 11.6-3.73a16.27 16.27 0 0 0 5.92-12.49c-.06-9.62-7.22-16.33-17.52-16.33Zm7.46 24.5c-2 1.77-4.56 2.6-8.7 2.6h-1.71v-21.52h1.76c4.08 0 6.57.71 8.7 2.61a10.92 10.92 0 0 1 3.49 8.1 11.2 11.2 0 0 1-3.54 8.23ZM1723.61 109.02h6.33v32.54h-6.33zM1745.44 121.51c-3.79-1.42-4.91-2.37-4.91-4.09 0-2.07 2-3.6 4.73-3.6a6.34 6.34 0 0 1 5.09 2.66l3.32-4.32a14.32 14.32 0 0 0-9.59-3.61c-5.74 0-10.18 4-10.18 9.35 0 4.49 2.07 6.8 8 8.93a30.61 30.61 0 0 1 4.38 1.84 4 4 0 0 1 1.89 3.37 4.62 4.62 0 0 1-4.91 4.61 7.57 7.57 0 0 1-6.92-4.31l-4.08 4c2.9 4.32 6.45 6.21 11.24 6.21 6.57 0 11.24-4.38 11.24-10.71.11-5.3-2.08-7.67-9.3-10.33ZM1756.8 125.35a16.84 16.84 0 0 0 17.16 17 17.32 17.32 0 0 0 7.93-1.89V133c-2.54 2.54-4.79 3.55-7.63 3.55-6.39 0-11-4.62-11-11.25 0-6.27 4.67-11.18 10.65-11.18 3 0 5.33 1.07 7.93 3.67v-7.46a16.17 16.17 0 0 0-7.81-2 17.14 17.14 0 0 0-17.23 17.02ZM1832.3 130.91l-8.7-21.89h-6.92l13.79 33.37h3.43l14.02-33.37h-6.86l-8.76 21.89zM1850.82 141.57h17.99v-5.51h-11.66v-8.75h11.24v-5.51h-11.24v-7.22h11.66v-5.56h-17.99v32.55zM1894 118.67c0-6.1-4.2-9.59-11.54-9.59H1873v32.54h6.33v-13.07h.83l8.76 13.07h7.81l-10.23-13.72c4.79-1.01 7.5-4.26 7.5-9.23Zm-12.78 5.38h-1.84v-9.88h2c4 0 6.1 1.66 6.1 4.85s-2.22 5.03-6.3 5.03Z"
    />
    <circle
      cx={1801.36}
      cy={125.41}
      r={17.34}
      style={{
        fill: 'url(#Sfumatura_senza_nome_3)',
      }}
    />
    <circle
      cx={1801.36}
      cy={125.41}
      r={17.34}
      style={{
        opacity: 0.65,
        isolation: 'isolate',
        fill: 'url(#Sfumatura_senza_nome_2)',
      }}
    />
    <path
      className="cls-3"
      d="M1898 110.27c0-.6-.41-.89-1.06-.89h-1v2.84h.71v-1.13l.83 1.13h.83l-.95-1.19a.71.71 0 0 0 .64-.76Zm-1.18.41h-.12v-.77h.12c.35 0 .53.12.53.36s-.2.41-.55.41Z"
    />
    <path
      className="cls-3"
      d="M1897 108.31a2.49 2.49 0 1 0 2.49 2.49 2.5 2.5 0 0 0-2.49-2.49Zm0 4.56a2.07 2.07 0 1 1 2-2.07 2 2 0 0 1-2 2.07Z"
    />
    <path
      className="cls-13"
      d="M1118.42 58.68h156.49v84.47l-7.74 12.11 7.74 10.77v49.13h-156.49v-79.63l4.85-5.57-4.85-5.32Z"
    />
    <path
      className="cls-9"
      d="M1148.8 167.72v-24.57h26l2.79 3.64 2.88-3.64h94.42V166a10.87 10.87 0 0 1-5.32 1.69h-52.27l-3.14-3.87v3.87h-10.31v-6.61a8.69 8.69 0 0 1-4.46.92h-3.51v5.69h-15.61l-2.79-3.71-2.83 3.71Zm-30.38-43.08 5.87-13.68h10.15l3.32 7.66V111h12.62l2 5.54 1.92-5.54h56.61v2.78a12.24 12.24 0 0 1 7.87-2.78l18.36.06 3.28 7.57V111H1251l2.9 4.34V111h10.65v24.57h-10.65l-2.78-4.36v4.36h-15.51l-1.55-3.87h-4.17l-1.54 3.87h-10.51a10.39 10.39 0 0 1-6.9-2.73v2.73H1195l-3.14-3.87v3.87h-59l-1.56-3.87h-4.15l-1.55 3.87h-7.25Z"
    />
    <path
      className="cls-13"
      d="m1126.37 114-7.92 18.4h5.16l1.46-3.69h8.48l1.46 3.69h5.26l-7.9-18.4Zm2.92 4.28 2.59 6.44h-5.18Zm11.52 14.11V114h7.32l4.26 11.86 4.16-11.88h7.26v18.39h-4.6v-13.54l-4.87 13.55h-4l-4.89-13.55v13.55Zm26.15 0V114h15v4.11h-10.36v3.15h10.12v3.87h-10.12v3.27h10.4v4Zm17.67-18.39v18.4h4.6v-6.54h1.93l5.52 6.54h5.62l-6.06-6.78a5.6 5.6 0 0 0 5-5.65c0-3.87-3-6-6.43-6Zm4.6 4.11h5.25a2.12 2.12 0 0 1 2.18 1.94 2.08 2.08 0 0 1-2.11 1.94h-5.32Zm18.63 14.28h-4.69V114h4.69Zm11.14 0h-1c-4.9 0-7.88-3.86-7.88-9.12s3-9.27 9.14-9.27h5.08v4.35h-5.27c-2.51 0-4.29 2-4.29 5 0 3.56 2 5.05 5 5.05h1.21Zm10-18.39-7.92 18.4h5.15l1.46-3.69h8.49l1.45 3.69h5.27L1235 114Zm2.92 4.28 2.59 6.44h-5.18Zm11.52 14.11V114h5.84l7.47 11.55V114h4.6v18.39h-5.66l-7.69-11.87v11.86Zm-91.5 32.2v-18.4h15v4.11h-10.34v3.15h10.11v3.87h-10.11v3.27h10.4v4Zm73.53 0v-18.4h15v4.11h-10.36v3.15h10.07v3.87h-10.07v3.27h10.36v4Zm-57.94 0 7.31-9.09-7.49-9.31h5.8l4.45 5.76 4.47-5.76h5.57l-7.38 9.2 7.32 9.2h-5.79l-4.33-5.67-4.22 5.67Zm20.6-18.4v18.4h4.72v-5.81h4.84c4.09 0 7.2-2.17 7.2-6.4 0-3.5-2.44-6.19-6.61-6.19Zm4.72 4.16h5.15a2.07 2.07 0 0 1 2.27 2.12 2.12 2.12 0 0 1-2.28 2.12h-5.08Zm14-4.16v18.4h4.59V158h1.94l5.51 6.54h5.63l-6.06-6.78a5.6 5.6 0 0 0 5-5.65c0-3.87-3-6-6.43-6Zm4.59 4.11h5.26a2.12 2.12 0 0 1 2.18 1.94 2.08 2.08 0 0 1-2.11 1.94h-5.33Zm31.13 14.29v-4h9.21c1.36 0 2-.73 2-1.54s-.59-1.56-2-1.56h-4.16c-3.62 0-5.63-2.2-5.63-5.51 0-2.95 1.84-5.79 7.21-5.79h9l-1.94 4.14h-7.74c-1.48 0-1.94.78-1.94 1.52a1.61 1.61 0 0 0 1.7 1.6h4.35c4 0 5.78 2.29 5.78 5.28 0 3.22-2 5.86-6 5.86Zm16.88 0v-4h9.21c1.36 0 2-.73 2-1.54s-.59-1.56-2-1.56h-4.16c-3.62 0-5.63-2.2-5.63-5.51 0-2.95 1.84-5.79 7.21-5.79h9l-1.94 4.14h-7.74c-1.48 0-1.94.78-1.94 1.52a1.6 1.6 0 0 0 1.7 1.6h4.35c4 0 5.78 2.29 5.78 5.28 0 3.22-2 5.86-6 5.86Z"
    />
    <g id="g6321">
      <g id="g6323">
        <path
          id="path6325"
          className="cls-9"
          d="M1581.93 183.06a31.75 31.75 0 0 1-31.71 31.71H1377.7V89.18a31.75 31.75 0 0 1 31.71-31.7h172.52v125.58Z"
        />
        <g id="g6327">
          <path
            id="path6338"
            d="M1525.75 150.85h13.11c.38 0 1.25-.12 1.63-.12a5.85 5.85 0 0 0 4.61-5.87 6.06 6.06 0 0 0-4.61-5.87 6.94 6.94 0 0 0-1.63-.12h-13.11v12Z"
            style={{
              fill: 'url(#Sfumatura_senza_nome_6)',
            }}
          />
          <path
            id="path6349"
            d="M1537.36 68.09a22.72 22.72 0 0 0-22.72 22.72v23.59h32.09a12.23 12.23 0 0 1 2.24.13c7.24.37 12.61 4.12 12.61 10.61 0 5.11-3.62 9.48-10.36 10.36v.25c7.37.5 13 4.62 13 11 0 6.87-6.24 11.36-14.48 11.36h-35.2v46.19h33.33a22.72 22.72 0 0 0 22.72-22.72V68.09Z"
            style={{
              fill: 'url(#Sfumatura_senza_nome_6-2)',
            }}
          />
          <path
            id="path6360"
            d="M1543.48 126.63a5.3 5.3 0 0 0-4.62-5.36c-.25 0-.87-.13-1.25-.13h-11.86v11h11.86a3.33 3.33 0 0 0 1.25-.13 5.3 5.3 0 0 0 4.62-5.38Z"
            style={{
              fill: 'url(#Sfumatura_senza_nome_6-3)',
            }}
          />
        </g>
        <path
          id="path6371"
          d="M1411.78 68.09a22.72 22.72 0 0 0-22.72 22.72v56.05c6.37 3.12 13 5.12 19.6 5.12 7.86 0 12.11-4.75 12.11-11.24v-26.46h19.47v26.34c0 10.23-6.36 18.6-28 18.6a95.79 95.79 0 0 1-23.34-2.87v47.81h33.33a22.72 22.72 0 0 0 22.77-22.72V68.09Z"
          style={{
            fill: 'url(#Sfumatura_senza_nome_4)',
          }}
        />
        <path
          id="path6384"
          d="M1474.57 68.09a22.72 22.72 0 0 0-22.72 22.72v29.71c5.74-4.87 15.73-8 31.84-7.24a101.17 101.17 0 0 1 17.85 2.74v9.62a43.14 43.14 0 0 0-17.23-5c-12.23-.87-19.6 5.12-19.6 15.61s7.37 16.6 19.6 15.6a45.35 45.35 0 0 0 17.23-5v9.61a99.41 99.41 0 0 1-17.85 2.75c-16.11.75-26.1-2.38-31.84-7.24v52.43h33.33a22.72 22.72 0 0 0 22.72-22.72V68.09Z"
          style={{
            fill: 'url(#Sfumatura_senza_nome_5)',
          }}
        />
      </g>
    </g>
  </svg>
);

export default CartePaypal;
